<div>

  <br/>
  <br/>
  <br/>

  <div class="container">
    <div class="row">
      <div class="col">
        <div class="text-center">
          <img class="center-block" ngSrc="/images/not-found/croissant-mascot-sad.png" alt="Sad Croissant mascot" height="200" width="200" priority/>
          <br/>
          <br/>
          <h1>Oh no!</h1>
          <h2>We couldn't find the page you were looking for.</h2>
          <br/>
          <br/>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row justify-content-center">
      <div class="col-auto text-center">
        <br/>
        <button class="btn btn-teal" routerLink="/" role="button">Back to homepage</button>
        <br/>
      </div>
      <div class="col-auto text-center">
        <br/>
        <button class="btn btn-teal" routerLink="/contact" role="button">Contact support</button>
        <br/>
      </div>
    </div>
  </div>

  <br/>
  <br/>
  <br/>

</div>
